import { Constant } from '@/_services/constant'

export default class CardModel {
  /* tslint:disable:variable-name */
  public _id: string = ''
  public san_id: string = ''
  public card_type: string
  public user_id: string = ''
  public user_name: string = ''
  public category_name: string = ''
  public category_color: string = ''
  public location_name: string = ''
  public floor_name: string = ''
  public lon: any = ''
  public lat: any = ''
  public floor_id: string = ''
  public geofence_name: string = ''
  public geofence_id: string = ''
  public created_at: Date = new Date()
  public updated_at: Date = new Date()
  public camera_address: string = ''

  constructor(type = Constant.CARD_TYPE_CARRIED) {
    this.card_type = type
  }
}
